import * as React from 'react';
import { themeGet } from 'styled-system';
import styled from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import Box from '../primitives/Box';
import { FieldProps } from 'formik';

type ToggleProps = StyledSystemProps & {
  disabled: boolean;
  onChanged: Function;
};

const InputWrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  height: 50%;
  padding: 20px;
  position: relative;
  border-radius: 24px;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
  box-sizing: border-box;
  justify-content: center;
  & input[type='checkbox'] {
    position: absolute;
    visibility: hidden;
  }
  & input[type='checkbox']:checked ~ label {
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background: ${themeGet('colors.putty', '#eee')};
  }
  & input[type='checkbox']:checked ~ label:before {
    content: 'YES';
    color: ${themeGet('colors.putty')};
  }
  & input[type='checkbox']:checked ~ label:before {
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: translateX(-100%);
  }
  @media screen and (max-width: 1440px) {
    flex: 1 0 31%;
    margin-right: 20px;
  }
  @media screen and (max-width: 1024px) {
    flex: 1 0 47%;
    margin-right: 20px;
  }
  @media screen and (max-width: 768px) {
    flex: 1 0 100%;
    margin-right: 0;
  }
`;

const RadioLabel = styled.label`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50%;
  color: #fff;
  display: flex;
  cursor: pointer;
  font-weight: bold;
  border-radius: 24px;
  position: absolute;
  font-weight: normal;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background: ${themeGet('colors.paleGrey')};
  box-shadow: 0px 0px 4px 0px rgba(50, 50, 93, 0.3) inset;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[2]};
  &:before {
    right: 0;
    width: 50%;
    display: flex;
    content: 'NO';
    height: 50%;
    background: #fff;
    position: absolute;
    border-radius: 24px;
    align-items: center;
    justify-content: center;
    height: 100%;
    box-shadow: 0px 0px 5px rgba(50, 50, 93, 0.3);
    color: ${themeGet('colors.transparentBlack')};
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

// const InputFeedback = ({ error }: { error: string }) => (error ? <div>{error}</div> : null);

const Toggle: React.FunctionComponent<ToggleProps & FieldProps> = (props) => {
  const {
    field,
    disabled,
  } = props;
  return (
    <Box
      borderRadius={150}
      mr={[0, 4]}
      height="100px"
      flex={['1 0 100%', '1 0 48%', '1 0 23%']}
      mb={3}
      width="100%"
     >
      <InputWrap>
        <input
          disabled={disabled}
          name={field.name}
          id={field.name}
          type="checkbox"
          value={field.value}
          checked={field.value}
          onChange={
            field.onChange
          }
          onBlur={field.onBlur}
        />
        <RadioLabel htmlFor={field.name} />
      </InputWrap>
    </Box>
  );
};

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledToggle.tsx